import { serviceHelper } from '../utils/serviceHelper'

export const findByPartnerCnpj = async ({ partner, cnpj }) => {
  const professionalApi = getAxiosCreate()
  const { data } = await professionalApi.get('/cnpj', {
    params: {
      partnerId: partner,
      cnpj
    }
  })
  return data
}

export const getAllFreelancersByProfessionalId = async (professionalId) => {
  const professionalApi = getAxiosCreate()
  const { data } = await professionalApi.get(`/freelancer?professionalId=${professionalId}`)
  return data
}

export const getSameProfessionalStore = async (partnerId, role = 'VETERINARIAN', category = 'FRANCHISING') => {
  const professionalApi = getAxiosCreate()
  const { data } = await professionalApi.get(`/${partnerId}/${role}/${category}`)
  return data
}

export const sendForgotPasswordEmail = async (professionalId) => {
  const professionalApi = getAxiosCreate()
  const { status } = await professionalApi.post(`/${professionalId}/forgot-password`, {})
  return status
}

export const saveNewPassword = async (professionalId, password) => {
  const professionalApi = getAxiosCreate()
  const { status } = await professionalApi.post(`/${professionalId}/save-new-password`, { password })
  return status
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_PARTNER_URL}/professionals`)
}
